@import '../../styles/palette';

.icon {
  font-size: 20px;
}

.buttonLeft {
  color: _palette(text-primary);
  padding: 0.5em 1em !important;
  border-right: none !important;
  border-color: _palette(border-strong) !important;

  &:hover:not(.Mui-disabled),
  &:focus:not(.Mui-disabled) {
    background-color: _palette(bg-primary) !important;
  }
}

.buttonRight {
  color: _palette(text-primary);
  padding: 0.5em 1em !important;
  border-left: none !important;
  border-color: _palette(border-strong) !important;

  &:hover:not(.Mui-disabled),
  &:focus:not(.Mui-disabled) {
    background-color: _palette(bg-primary) !important;
  }
}

.buttonZoom {
  &:hover:not(.Mui-disabled),
  &:focus:not(.Mui-disabled) {
    background-color: _palette(bg-primary) !important;
  }

  &,
  &:hover {
    text-transform: none;
    padding: 0.25em 0.75em !important;
    color: _palette(text-primary);
    border-left: none;
    border-color: _palette(border-strong);
  }
}

.buttons {
  vertical-align: middle;
}

.iconButton {
  margin-top: -3px;
  padding: 1px;
}

.clearIcon {
  width: 18px;
  height: 18px;
}

.activityStatusFilterSelect {
  height: 52px;
  border: 1px solid _palette(bg-primary-dark);
  border-left: none;
}

.activityStatusFilterMenuItem {
  padding: 9px 22px;
}
